import $ from 'jquery';

export default class ParameterService {
    constructor() {

    }


    getParameters(successCallback, errorCallback) {

        $.ajax({
            url: '/api/parameters',
            type: "GET",
            contentType: "application/json",

            success: successCallback,
            error: errorCallback
        });

    }

    getLp5Configuration(lp5, successCallback, errorCallback) {

        $.ajax({
            url: '/api/lp5configuration',
            type: "GET",
            data: { lp5 },
            contentType: "application/json",

            success: successCallback,
            error: errorCallback
        });

    }

}